import { LoadingStatus } from '../types'

// use keys instead of sequence numbers (stored in cookie)
// plus, it's easier to debug
export enum BookingSteps {
  ServiceSelection = 'ServiceSelection',
  ZipCode = 'ZipCode',
  Age = 'Age',
  IsParent = 'IsParent',
  LegalGuardian = 'LegalGuardian',
  AgeInYears = 'AgeInYears',
  Diagnosis = 'Diagnosis',
  Insurance = 'Insurance',
  ParentInfo = 'ParentInfo',
  CreateAccount = 'CreateAccount',
  Provider = 'Provider',
  TimeSlots = 'TimeSlots',
  SchedulingConfirmation = 'SchedulingConfirmation',
  CallNowConfirmation = 'CallNowConfirmation',
  CallLaterConfirmation = 'CallLaterConfirmation',
  NotQualified = 'NotQualified',
  DiagnosisOfframp = 'DiagnosisOfframp',
  DiagnosisOfframpWithoutSupport = 'DiagnosisOfframpWithoutSupport',
  LegalGuardianOfframp = 'LegalGuardianOfframp',
  PostalCodeOfframp = 'PostalCodeOfframp',
  AgeOfframp = 'AgeOfframp'
}

export const INITIAL_STEP = BookingSteps.ZipCode

interface BookingFlowData {
  currentStep?: BookingSteps
  previousStep?: BookingSteps
  backStep?: boolean // last navigation occured to this step was a 'step back'
  stepsNumber: number
  currentUtcTime?: string // ISO8601
  timeSlots?: number[]
  isTimeSlotChosen?: boolean
  dateFrom?: number
  dateTo?: number
}

export interface NavigationState {
  step: BookingSteps
}

export interface BookingInputData {
  zipCode?: string
  isZipCodeSupported?: IsZipCodeSupported
  provinceCode?: string
  age?: ChildAges | LeadAgeRange
  ageInYears?: number
  isParentUserAnswer?: string
  legalGuardianUserAnswer?: string
  diagnosisUserAnswer?: string
  isDiagnosed?: IsDiagnosed
  isInsured?: IsInsured
  provider?: string
  firstName?: string
  lastName?: string
  fullName?: string
  email?: string
  phone?: string
  smsOptout?: boolean
  timeZoneOffset?: string
  timeZoneAbbreviation?: string
  timeSlot?: string
  bookingType?: string
}

interface BookingFlowError {
  message: string
}

export interface BookingState {
  createLeadStatus: LoadingStatus
  initBookingFlowStatus: LoadingStatus
  initBookingFlowError: BookingFlowError | string
  status: LoadingStatus
  flowData: BookingFlowData
  inputData: BookingInputData
  error: string
  createLeadError: string
  bookingUserId?: string
  authFlowId?: string
}

export enum BookingInputFieldsNames {
  zipCode = 'zipCode',
  isZipCodeSupported = 'isZipCodeSupported',
  provinceCode = 'provinceCode',
  age = 'age',
  isParentUserAnswer = 'isParentUserAnswer',
  legalGuardianUserAnswer = 'legalGuardianUserAnswer',
  isParent = 'isParent',
  isLegalGuardian = 'isLegalGuardian',
  diagnosisUserAnswer = 'diagnosisUserAnswer',
  isDiagnosed = 'isDiagnosed',
  isInsured = 'isInsured',
  provider = 'provider',
  firstName = 'firstName',
  lastName = 'lastName',
  fullName = 'fullName',
  email = 'email',
  phone = 'phone',
  smsOptout = 'smsOptout',
  timeZoneOffset = 'timeZoneOffset',
  timeZoneAbbreviation = 'timeZoneAbbreviation',
  timeSlot = 'timeSlot',
  bookingType = 'bookingType'
}

export enum IsZipCodeSupported {
  Yes = 'true',
  No = 'false'
}

export enum ChildAges {
  YRS_0_3 = '0-3yrs',
  YRS_4_7 = '4-7yrs',
  YRS_8_9 = '8-9yrs',
  YRS_MORE_10 = '10+yrs'
}

export enum LeadAgeRange {
  '0-3yrs' = 'YRS_0_3',
  '4-7yrs' = 'YRS_4_7',
  '8-9yrs' = 'YRS_8_9',
  '10+yrs' = 'YRS_MORE_10'
}

export enum IsParent {
  Yes = 'yes',
  No = 'no'
}

export enum IsLegalGuardian {
  Yes = 'yes',
  No = 'no'
}

export enum IsDiagnosed {
  Yes = 'yes',
  No = 'no',
  Unknown = 'unknown'
}

export enum LeadDiagnosisStatus {
  yes = 'YES',
  no = 'NO',
  unknown = 'I_DONT_KNOW'
}

export enum IsInsured {
  Yes = 'yes',
  No = 'no'
}

export enum NotQualifyingReasons {
  Age = 'age',
  Location = 'location',
  Diagnosis = 'diagnosis' // A/B tests only
}

// Actions
export interface SetTimeSlotsAction {
  dateFrom: number
  dateTo: number
  timeSlots?: number[]
}
